import { AppLayout } from "../shared";
import AdminAccount from "../Admin/AdminAccount";

const AdminAccount_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <AdminAccount props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default AdminAccount_layout;
